import React from 'react'
import Table from '@common/Table'
import getColumns from './columns'

export default ({ store, open }) => (
  <Table store={store} columns={getColumns(store, open)} />
)
